import React from "react";
import { Route, Routes } from "react-router-dom";
import { createSignalRContext } from "react-signalr/signalr";
import Subject from "./Subject";
import { Box, Image } from "grommet";
import Login from "./Login";
export const SignalRContext = createSignalRContext();

const Admin = () => {
    return (
        <SignalRContext.Provider url={"/collabHub"}>
            <Box align="center" pad={"small"}>
                <Image src="/logo.png" width={"500px"}></Image>
            </Box>
            <Routes>
                <Route path="/" element={<Login />}></Route>
                <Route path="/subject" element={<Subject />}></Route>
            </Routes>
        </SignalRContext.Provider>
    );
};

export default Admin;
